var TABLE_PAGER = function() {

	this.setPage = function (pageIndex, pageCount){
	
		var pageNumbers = "";
		
		if(pageIndex > 1){
			pageNumbers += '<a class="page" href="#">1</a>';
			if(pageIndex != 2){
				pageNumbers += '<span class="dotlinks">...</span>';
			}
		}
		
		var diff = pageIndex == 0 ? 0 : -1;
		
		for(var i = 0; i < 4; i++){
			
			if(pageIndex + 1 + diff > pageCount){
				break;
			}
			
			if(diff == 0){
				pageNumbers += '<a class="page selected" href="#">%s</a>'.replace("%s",pageIndex + 1);
			} else {
				pageNumbers += '<a class="page" href="#">%s</a>'.replace("%s",pageIndex + 1 + diff);
			}
			
			diff++;
		}
		
		if(pageIndex + 3 < pageCount){
			if(pageIndex + 3 < pageCount -1){
				pageNumbers += '<span class="dotlinks">...</span>';
			}
			pageNumbers += '<a class="page" href="#">%s</a>'.replace("%s",pageCount);
		}
		
		$(".pager-numbers").empty();
		$(pageNumbers).appendTo(".pager-numbers");	
	}
	
	return {
		setPage : setPage,
	}

}();